
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#FF5D15"}}),_c('path',{attrs:{"d":"M16.5 11h-3.938a.562.562 0 00-.562.563v15.75a.562.562 0 00.563.562H16.5a.562.562 0 00.563-.563v-15.75A.562.562 0 0016.5 11zM26.313 11h-3.938a.562.562 0 00-.563.563v15.75a.562.562 0 00.563.562h3.938a.562.562 0 00.562-.563v-15.75a.562.562 0 00-.563-.562z","fill":"#fff"}})])
          )
        }
      }
    